import classNames from "classnames"
import React from "react"

export type NavbarProps = React.HTMLAttributes<HTMLDivElement>

export const Navbar = ({ className, ...props }: NavbarProps) => (
  <header className={classNames("navbar", className)} {...props} />
)
